import React, { lazy } from 'react';
const CHECKOUT_URL = 'https://ready-tennis.impultienda.ar/checkout';
const PRICE = 27;
const NORMAL_PRICE = 97;
const DISCOUNT = 72;
const BOX_IMAGE = 'https://cdn.magicpatterns.com/uploads/h6mpa7ij6oiFfoHP6CKTtz/Diseno-sin-titulo-_76_.webp';
const included = ['6 Complete Coaching Volumes (120+ modules)', '50 Plug-and-Play Session Blueprints', 'The "3-6-10" Group Scaling System', '5 Strategic Bonuses (worth $450+)', 'Lifetime Updates — pay once, keep forever'];
export function PricingSection() {
  return <section id="pricing" aria-label="Pricing and offers" className="bg-brand-dark py-8 md:py-24 px-4 border-t border-brand-border" data-id="element-176">
      <div className="max-w-xl mx-auto" data-id="element-177">
        {/* Eyebrow + headline */}
        <div className="text-center mb-5 md:mb-8" data-id="element-178">
          <p className="text-brand-accent font-badge font-black tracking-[0.2em] text-[10px] md:text-sm uppercase mb-1.5 md:mb-3" data-id="element-179">
            Special Offer — Complete 6-in-1 Pack
          </p>
          <h2 className="text-xl md:text-3xl font-heading font-black text-white leading-snug" data-id="element-180">
            Get the entire system today and{' '}
            <span className="text-brand-accent" data-id="element-181">reclaim your Sundays</span>
          </h2>
        </div>

        {/* Offer card */}
        <div className="relative bg-brand-card border-2 border-brand-accent/60 rounded-2xl md:rounded-3xl p-4 md:p-9 shadow-[0_0_50px_rgba(0,255,133,0.12)]" data-id="element-182">
          {/* Floating most-popular badge */}
          <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2" data-id="element-183">
            <div className="bg-brand-accent text-brand-dark font-badge font-black text-[9px] md:text-xs uppercase tracking-widest px-4 py-1 md:py-1.5 rounded-full shadow-[0_4px_20px_rgba(0,255,133,0.4)] whitespace-nowrap" data-id="element-184">
              ⭐ Most Popular Choice
            </div>
          </div>

          {/* Product row: image + name */}
          <div className="flex items-center justify-center gap-3 md:gap-4 mt-3 md:mt-4 mb-4 md:mb-5 pb-4 md:pb-5 border-b border-brand-border" data-id="element-185">
            <img src={BOX_IMAGE} alt="Tennis Ready — The Ultimate Pro Bundle, 6-in-1 box set" loading="lazy" decoding="async" width={420} height={420} className="w-16 h-16 md:w-24 md:h-24 object-contain flex-shrink-0" data-id="element-186" />
            <div className="text-left" data-id="element-187">
              <p className="text-white font-heading font-black text-base md:text-2xl leading-tight" data-id="element-188">
                Tennis Ready 6-in-1 Box Set
              </p>
              <p className="text-white/60 text-[11px] md:text-sm font-medium mt-0.5" data-id="element-189">
                For coaches & teaching pros · Instant PDF
              </p>
            </div>
          </div>

          {/* What's included — value stack */}
          <ul className="space-y-2 md:space-y-2.5 mb-4 md:mb-6" data-id="element-190">
            {included.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-white/90 text-[13px] md:text-base font-medium leading-snug" data-id="element-191">
                <span className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-brand-accent/15 text-brand-accent flex items-center justify-center text-xs md:text-sm font-black mt-0.5" aria-hidden="true" data-id="element-192">
                  ✓
                </span>
                <span data-id="element-193">{item}</span>
              </li>)}
          </ul>

          {/* MONEY ZONE — price sits directly above the button */}
          <div className="bg-brand-dark border border-brand-accent/30 rounded-xl md:rounded-2xl px-4 py-4 md:px-6 md:py-6 text-center" data-id="element-194">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-1 md:mb-2" data-id="element-195">
              <span className="text-white/50 line-through font-bold text-sm md:text-xl" data-id="element-196">
                ${NORMAL_PRICE}
              </span>
              <span className="bg-[#FF1E00] text-white font-black text-[10px] md:text-sm px-2.5 md:px-3 py-0.5 md:py-1 rounded-full uppercase tracking-wider flex items-center gap-1" data-id="element-197">
                <span aria-hidden="true" data-id="element-198">🔥</span> {DISCOUNT}% OFF
              </span>
            </div>
            <div className="leading-none flex items-baseline justify-center" data-id="element-199">
              <span className="font-heading font-black text-brand-accent text-6xl md:text-8xl leading-none tracking-tighter" data-id="element-200">
                ${PRICE}
              </span>
              <span className="font-heading font-black text-white text-2xl md:text-4xl leading-none tracking-tight ml-1.5" data-id="element-201">
                USD
              </span>
            </div>
            <p className="text-brand-accent font-bold text-[11px] md:text-base mt-1.5 md:mt-2" data-id="element-202">
              You save ${NORMAL_PRICE - PRICE} today
            </p>
            <p className="text-white/50 font-bold tracking-widest text-[9px] md:text-xs uppercase mt-1" data-id="element-203">
              💳 One-time · Pay in your local currency
            </p>

            {/* Main CTA — directly under price */}
            <button onClick={() => window.open(CHECKOUT_URL, '_blank')} aria-label={`Buy for $${PRICE}`} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-base md:text-2xl py-4 md:py-6 rounded-xl md:rounded-2xl transition-all flex items-center justify-center gap-2 active:scale-[0.98] shadow-[0_8px_30px_rgba(0,255,133,0.35)] animate-pulse-slow mt-4 md:mt-5 pt-[20px] pb-[20px]" data-id="element-204">
              🚀 YES, I WANT THE 6-IN-1 PACK
            </button>

            {/* CTA microcopy */}
            <p className="text-center text-white/55 text-[10px] md:text-sm font-medium mt-2 md:mt-3" data-id="element-205">
              ⚡ Instant access in 5 min · 🔒 Secure SSL checkout
            </p>
          </div>

          {/* Guarantee line */}
          <div className="flex items-center justify-center gap-2 mt-3 md:mt-5 text-center" data-id="element-206">
            <span className="text-lg md:text-xl" aria-hidden="true" data-id="element-207">
              🛡️
            </span>
            <p className="text-white/80 text-[11px] md:text-sm font-semibold leading-tight" data-id="element-208">
              Backed by our{' '}
              <span className="text-brand-accent font-black" data-id="element-209">
                7-Day Zero-Risk Guarantee
              </span>{' '}
              — refunded in full, no questions asked.
            </p>
          </div>

          {/* Trust row */}
          <div className="flex items-center justify-center gap-x-3 md:gap-x-5 mt-3 md:mt-4 pt-3 md:pt-4 border-t border-brand-border text-white/80 font-bold text-[10px] md:text-sm" data-id="element-210">
            <span className="flex items-center gap-1.5" data-id="element-211">
              <span className="text-brand-accent" data-id="element-212">⭐</span> 4.9/5 Reviews
            </span>
            <span className="text-white/20" aria-hidden="true" data-id="element-213">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-214">
              <span className="text-brand-accent" data-id="element-215">🌍</span> +2,500 Coaches
            </span>
          </div>
        </div>
      </div>
    </section>;
}